import api from "./api";

const LS_KEY = "rj_show_home_stats";
const LS_SETTINGS = "rj_public_settings";
let cache = null;

// Reads all public site settings (global backend value, with localStorage fallback).
export const getPublicSettings = async () => {
  if (cache) return cache;
  let local = {};
  try { local = JSON.parse(localStorage.getItem(LS_SETTINGS) || "{}"); } catch (e) { /* noop */ }
  try {
    const { data } = await api.get("/settings/public");
    if (data && typeof data === "object") { cache = { ...local, ...data }; return cache; }
  } catch (e) { /* endpoint not deployed yet */ }
  cache = local;
  return cache;
};

export const getShowHomeStats = async () => {
  const s = await getPublicSettings();
  if (typeof s.show_home_stats === "boolean") return s.show_home_stats;
  return localStorage.getItem(LS_KEY) === "true";
};

// Admin-only: persists a partial settings update (global via backend + localStorage mirror).
export const setPublicSettings = async (partial) => {
  let local = {};
  try { local = JSON.parse(localStorage.getItem(LS_SETTINGS) || "{}"); } catch (e) { /* noop */ }
  const merged = { ...local, ...partial };
  localStorage.setItem(LS_SETTINGS, JSON.stringify(merged));
  cache = { ...(cache || {}), ...partial };
  try {
    await api.put("/settings/public", partial);
    return true;
  } catch (e) {
    return false;
  }
};

export const setShowHomeStats = async (value) => {
  localStorage.setItem(LS_KEY, value ? "true" : "false");
  return setPublicSettings({ show_home_stats: value });
};
